import { render, staticRenderFns } from "./StoryPathsList.vue?vue&type=template&id=70857a64&"
import script from "./StoryPathsList.vue?vue&type=script&lang=ts&"
export * from "./StoryPathsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports